import { configRequest } from 'config-request';
import { defineStore } from 'pinia';
import { SwitchType } from 'config-request/src/interfaces/switch-3d';
import { getRequestIns } from '../requestIns';
export const formatToHump = (() => {
    const cache = {};
    return (str) => cache[str] ||
        (cache[str] = str.replace(/[-_](\w)/g, (_, letter) => letter.toUpperCase()));
})();
export const useSwitch3D = defineStore('switch3D', {
    state() {
        return {
            data: null,
            config3DOptions: {
                carMap: {},
                unity: {},
            },
        };
    },
    actions: {
        async querySwitch(params, ...options) {
            try {
                const result = await configRequest(getRequestIns())
                    .switch3D(params, ...options)
                    .catch(() => {
                    return {
                        data: {
                            switch_type: SwitchType.New,
                            web_pack: undefined,
                            model_list: undefined,
                        },
                    };
                });
                result.data?.model_list?.forEach(({ model_code, res_url, generation_list }) => {
                    this.config3DOptions.carMap[model_code] = { res_url };
                    if (generation_list) {
                        this.config3DOptions.carMap[model_code].generation_list =
                            generation_list;
                    }
                });
                Object.entries(result.data?.web_pack ?? {}).forEach(([key, value]) => (this.config3DOptions.unity[formatToHump(key)] = value));
                if (!result) {
                    return {
                        result,
                        config3DOptions: this.config3DOptions,
                    };
                }
                if (result.data.switch_type === SwitchType.History) {
                    this.data = result.data;
                    return {
                        result: this.data,
                        config3DOptions: this.config3DOptions,
                    };
                }
                if (!result.data?.web_pack) {
                    result.data.switch_type = SwitchType.New;
                }
                else {
                    const modelResult = result.data.model_list?.find((model) => model.model_code === params.model_code);
                    if (!modelResult) {
                        result.data.switch_type = SwitchType.New;
                    }
                }
                if (params.model_code &&
                    !this.config3DOptions.carMap[params.model_code].res_url) {
                    result.data.switch_type = SwitchType.New;
                }
                this.data = result.data;
                return {
                    result: this.data,
                    config3DOptions: this.config3DOptions,
                };
            }
            catch (error) {
                console.log('---error---', error);
                return {
                    result: null,
                    config3DOptions: this.config3DOptions,
                };
            }
        },
    },
});
